import React, { useState } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import imageService from '../../service/ImageServie';

function AdCard({ advertisement, onViewDetails }) {

  const [showNumber, setShowNumber] = useState(false);

  const formatPhoneNumber = (phoneNumber) => {
    // Format phone number as (XXX) XXX-XXXX
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  };

  const handlePhoneClick = (phone) => {
    if (showNumber) {
      // Initiate a call (this will only work if your environment supports such functionality)
      window.location.href = `tel:${phone}`;
    }
    else {
      // Make the phone number visible
      setShowNumber(true);
    }
  };

  return (<>
      <Card className="internal_ads_row border-blk mb-3 col-md-11 px-0">
        <Row className='mx-0 justify-content-center'>
          {advertisement.imageName && (
            <Col lg={3} md={4} className='p-0 align-content-around ad_banner'>
              <Card.Img variant="top"
                src={`${imageService.getAdsImage}${advertisement.imageName}`}
                alt={advertisement.companyName}
              />
            </Col>
          )}
          <Col lg={advertisement.imageName ? 9 : 12} md={advertisement.imageName ? 8 : 12}>
            <Card.Body className='p-0 planCard-style text-left'>
              <Row>
                <Col md={12} className='planInfo-style'>
                  <div className='row'>

                    <div className='col-md-12'>
                      <div className='row align-items-center'>
                        <div className='cardText col-lg-4 col-md-4 col-6'>
                          <span className='ad_miles mb-0'>{advertisement.distance.toFixed(1)} miles</span>
                        </div>

                        <div className='cardText col-lg-4 col-md-4 col-6'>
                          <h6 className='ad_worktype'><b>{advertisement.shopType || 'Not Available'}</b></h6>
                        </div>

                        <div className='col-lg-4 col-md-4 col-12 d-lg-block d-md-block d-none'>
                          <div className='planPrice-style p-0 text-right'>
                            <h6 className='ad_hours'><i className="far fa-clock" title="time"></i> {advertisement.workingHours}</h6>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='cardText col-md-12'>
                          <Card.Title style={{ cursor: "pointer" }} onClick={() => onViewDetails(advertisement.id, advertisement.companyName)}>
                            {advertisement.companyName}
                          </Card.Title>
                    </div>

                    <div className='col-md-12'>
                      <div className='cardText d-lg-flex gap-3'>
                        <p className='ad_address mb-0'><i className="fas fa-location-dot" title="location"></i> {advertisement.address || `${advertisement.city}, ${advertisement.state}`}</p>
                        <p className='ad_email mb-0'><i className="fa fa-envelope" title="email"></i> {advertisement.email || 'Not Available'}</p>
                        <p className='ad_website mb-0'><i className="fa fa-globe" title="website"></i>
                          <a href={advertisement.website} rel="noopener noreferrer"> {advertisement.website || 'Not Available'}</a>
                        </p>
                      </div>
                    </div>

                    <div className='col-md-12'>
                      <div className='ad_services my-1'>
                        <ul className='ad_serviceList'>
                          {advertisement.services.slice(0, 4).map((service, index) => (
                            <li key={index}>{service}</li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div className='col-md-12'>
                      <div className="ad_description">
                        <p className='mb-0'>
                         {advertisement.description?.length > 75
                            ? <>
                              {advertisement.description.slice(0, 75)}...
                              <span
                                className="read-more-link"
                                onClick={() => onViewDetails(advertisement.id, advertisement.companyName)}
                              > Read more</span>
                            </>
                            : advertisement.description
                          }
                        </p>
                      </div>
                    </div>

                    <div className='col-md-12 d-lg-none d-md-none d-block'>
                      <div className='planPrice-style p-0'>
                        <h6 className='ad_hours'><i className="far fa-clock" title="time"></i> {advertisement.workingHours}</h6>
                      </div>
                    </div>

                    <div className='col-md-12'>
                    <div className='new-ad-bottom d-flex justify-content-between align-items-center mt-2'>

                      <div className='bd_plan_contact'>
                        <a href={`tel:${advertisement.phone}`} className="btn showNumber">
                          <i className="fa fa-phone"></i> {formatPhoneNumber(advertisement.phone)}
                        </a>
                      </div>

                      <div className="planPrice-style p-0">
                        <Button className='planBtn' variant="primary" onClick={() => onViewDetails(advertisement.id, advertisement.companyName)}>View Detail</Button>
                      </div>

                    </div>
                    </div>
                  </div>

                </Col>
              </Row>
            </Card.Body>
          </Col>

        </Row>
      </Card>
  </>

  );
}

export default AdCard;